import React from 'react';
import { cn } from '@rocco/utils/cn';
import { ParticipantAvatar } from './ParticipantAvatar';

type ParticipantAvatarProps = React.ComponentProps<typeof ParticipantAvatar>;

/**
 * One or more avatars for participants in a conversation. Can be used to display
 * avatars for groups chats with multiple participants.
 */
export function ParticipantAvatars({
    className,
    imageClassName,
    fallbackClassName,
    containerClassName,
    size,
    participants,
    maxAvatars = 3,
}: {
    className?: string;
    imageClassName?: string;
    fallbackClassName?: string;
    containerClassName?: string;
    size?: ParticipantAvatarProps['size'];
    participants: NonNullable<ParticipantAvatarProps['participant']>[];
    maxAvatars?: number;
}) {
    const slicedParticipants = participants.slice(0, maxAvatars);

    return slicedParticipants.length === 1 ? (
        <ParticipantAvatar
            className={className}
            imageClassName={imageClassName}
            fallbackClassName={fallbackClassName}
            size={size}
            participant={slicedParticipants[0]}
        />
    ) : (
        <div className={cn('flex items-center -space-x-4', containerClassName)}>
            {slicedParticipants.map((participant) => (
                <ParticipantAvatar
                    key={participant.ID}
                    className={className}
                    imageClassName={imageClassName}
                    fallbackClassName={fallbackClassName}
                    size={size}
                    participant={participant}
                />
            ))}
        </div>
    );
}
